export function isNumber(value) {
  return /^\d+$/.test(value);
}


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/utils/validate/number.js
// module id = 106
// module chunks = 4